import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=bef366f2&"
import script from "./MyProfile.vue?vue&type=script&lang=ts&"
export * from "./MyProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports